/*
 * Jira Ticket:
 * Created Date: Wed, 3rd Jun 2020, 14:54:23 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React, { Fragment } from 'react';
import {
  Edit,
  TextInput,
  SimpleForm,
  Title,
  usePermissions,
  useDataProvider,
  useNotify,
  SaveButton,
  Toolbar,
  required,
} from 'react-admin';
import { AccessDenied } from 'Layout';
import { isSuperAdmin } from 'utils/roles';
import { nonNegativeNonZeroInt } from 'utils/validation';

const numberValidation = [required(), nonNegativeNonZeroInt];

const ConfigurationItemEdit = props => {
  const resource = 'ConfigurationItem';
  const { permissions } = usePermissions();
  const dataProvider = useDataProvider();
  const notify = useNotify();

  return isSuperAdmin(permissions) ? (
    <Fragment>
      <Title title={`resources.General.cmsTitle`} />
      <Edit title={`resources.${resource}.title`} {...props}>
        <SimpleForm>
          <TextInput
            source="key"
            validate={required()}
            label={`resources.${resource}.fields.key`}
            fullWidth
          />
          <TextInput
            source="value"
            validate={required()}
            label={`resources.${resource}.fields.value`}
            multiline
            fullWidth
          />
        </SimpleForm>
      </Edit>
    </Fragment>
  ) : (
    <AccessDenied />
  );
};

export default ConfigurationItemEdit;
